const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
  total: 0,
  fetchError: null
};

export default function spaces (state = initialState, action) {
  const { data, total, fetchError, type } = action;

  if ('SPACES_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('SPACES_FETCH_REQUEST' === type) {
    return { ...state, isFetching: true };
  }

  if ('SPACES_FETCH_SUCCESS' === type) {
    return {
      ...state,
      data,
      total: 'number' === typeof total ? total : data.length,
      hasFetched: true,
      isFetching: false
    };
  }

  if ('SPACES_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  return state;
}
